<div class="pt-10 px-10 pb-10">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-2xl font-bold">Cargos do Sistema</h1>
    <div class="flex space-x-4">
      <button
      type="submit"
      class="bg-primary text-white py-2 px-4 rounded-lg flex items-center"
      (click)="novoCargo()"
      >
      <mat-icon class="mr-2 small-icon">add</mat-icon>
      Novo Cargo
      </button>
    </div>
  </div>

  <div class="bg-white shadow rounded-lg p-4 mb-4">
    <div class="flex">
      <div class="relative mb-4 flex-grow">
        <mat-icon *ngIf="!isLoading" class="absolute left-2 top-2 text-gray-500"
          >search</mat-icon
        >
        <div
          *ngIf="isLoading"
          class="absolute left-2 top-2 flex items-center justify-center"
        >
          <mat-spinner [diameter]="20" color="primary"></mat-spinner>
        </div>
        <input
          type="text"
          placeholder="Buscar cargos"
          class="w-full p-2 pl-10 border border-gray-200 rounded-lg input-field-focus"
          [formControl]="searchControl"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
    </div>

    <div class="flex items-end text-primary-gray text-sm justify-between">
      <div class="flex align-certer justify-center items-end">
        <!-- Adicione filtros aqui -->
      </div>
      <div>
        <span class="mr-2">Resultados por página:</span>
        <select
          (change)="changePageSize($event)"
          class="p-2 border border-gray-200 rounded-lg input-field-focus"
        >
          <option
            *ngFor="let size of [5, 10, 25, 50, 100]"
            [value]="size"
            [selected]="size === 10"
          >
            {{ size }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div>
    <ngx-datatable
      class="material pointer"
      [rows]="cargos"
      [columns]="columns"
      [columnMode]="ColumnMode.flex"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [externalPaging]="true"
      [count]="page.count"
      [offset]="page.page"
      [limit]="page.pageSize"
      (page)="onPage($event)"
      (sort)="onSort($event)"
      (activate)="onRowClick($event)"
      [messages]="{
        emptyMessage: isLoading
          ? 'Buscando resultados...'
          : 'Nenhum cargo encontrado, tente alterar os filtros.',
        totalMessage: 'cargos encontrados'
      }"
    >
      <ngx-datatable-column
        prop="cargo"
        name="Cargo"
        [headerClass]="'text-xs'"
        [flexGrow]="5"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="text-sm font-semibold text-primary-dark">{{
            row.name
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        prop="usuarios"
        name="Usuários"
        [headerClass]="'text-xs'"
        [flexGrow]="5"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <button (click)="openUserListDialog(row.id); $event.stopPropagation()">
            <span *ngIf="row.totalUsers" class="px-2 py-1 rounded-full text-xs text-item-blue-text bg-item-blue-bg">
              {{ row.totalUsers === 1 ? '1 usuário' : row.totalUsers + ' usuários' }}
            </span>
            <span *ngIf="!row.totalUsers" class="italic text-xs">
              nenhum usuário
            </span>
          </button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Ações"
        [headerClass]="'text-xs'"
        [flexGrow]="1"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <button
            mat-icon-button
            (click)="editPermissoes(row.id); $event.stopPropagation()"
          >
            <i class="fa-solid fa-pen-to-square text-gray-500"></i>
          </button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="h-24"></div>
</div>
